import { Box, Stack, Text } from "@bookingcom/bui-react";

export type AverageDiscountTooltipRow = {
  name: string;
  percentage?: number;
  euro?: number;
  color: string;
};

export type AverageDiscountTooltipProps = {
  title: string;
  rows: AverageDiscountTooltipRow[];
};

export const AverageDiscountTooltip = ({ title, rows }: AverageDiscountTooltipProps) => (
  <Box backgroundColor="elevation_one" borderRadius={200} padding={0} overflow="hidden">
    <Box backgroundColor="neutral_alt" padding={3}>
      <Text variant="strong_2">{title}</Text>
    </Box>
    <Stack gap={2} mixin={{ padding: 3 }}>
      {rows.map(({ name, percentage, euro, color }) => (
        <Stack key={name} direction="row" alignItems="start" justifyContent="space-between" gap={2}>
          <Stack direction="row" alignItems="center" gap={2}>
            <Box
              borderRadius="circle"
              padding={1.5}
              attributes={{ style: { backgroundColor: color, flexShrink: 0 } }}
            />
            <Text variant="body_2">{name}</Text>
          </Stack>
          <Stack gap={0} alignItems="end">
            <Text variant="strong_2">{percentage !== undefined ? `${percentage?.toFixed(1)}%` : "-"}</Text>
            <Text variant="small_1" color="neutral_alt">
              {euro !== undefined ? `€${Math.round(euro)}` : "-"}
            </Text>
          </Stack>
        </Stack>
      ))}
    </Stack>
  </Box>
);
